export const SVGImage = ({
  color,
  type,
}: {
  color: string;
  type: "decrease-arrow" | "increase-arrow" | "stable-arrow";
}) => {
  switch (type) {
    case "decrease-arrow":
      return (
        <svg
          width="15"
          height="9"
          viewBox="0 0 15 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.196133 0.196133C0.441426 -0.0491672 0.829363 -0.0643027 1.09252 0.150332L1.14355 0.196133L5.02484 4.0774L7.90115 1.20113L7.9522 1.15533C8.21531 0.940697 8.60324 0.955833 8.84853 1.20113L14.5435 6.89615L14.5894 6.94714C14.804 7.21032 14.7889 7.59825 14.5435 7.84353C14.2982 8.08882 13.9103 8.10396 13.6472 7.88936L13.5961 7.84353L8.37484 2.62226L5.49855 5.49853C5.2369 5.76024 4.81278 5.76024 4.55113 5.49853L0.196133 1.14355L0.150331 1.09252C-0.0643037 0.829363 -0.0491658 0.441434 0.196133 0.196133Z"
            fill={color}
          />
          <path
            d="M13.3799 3.33992C13.3799 2.96988 13.6798 2.66992 14.0499 2.66992C14.4199 2.66992 14.7199 2.96988 14.7199 3.33992V7.35992C14.7199 7.72996 14.4199 8.02992 14.0499 8.02992H10.0299C9.65982 8.02992 9.35986 7.72996 9.35986 7.35992C9.35986 6.98988 9.65982 6.68992 10.0299 6.68992L13.3799 6.68992V3.33992Z"
            fill={color}
          />
        </svg>
      );

    case "increase-arrow":
      return (
        <svg
          width="15"
          height="9"
          viewBox="0 0 15 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.196133 7.84353C0.441426 8.08883 0.829363 8.10397 1.09252 7.88933L1.14355 7.84353L5.02484 3.96227L7.90115 6.83853L7.9522 6.88433C8.21531 7.09897 8.60324 7.08383 8.84853 6.83853L14.5435 1.14351L14.5894 1.09252C14.804 0.829347 14.7889 0.441418 14.5435 0.196131C14.2982 -0.0491568 13.9103 -0.0642984 13.6472 0.150303L13.5961 0.196131L8.37484 5.4174L5.49855 2.54113C5.2369 2.27943 4.81278 2.27943 4.55113 2.54113L0.196133 6.89611L0.150332 6.94714C-0.0643036 7.2103 -0.0491657 7.59823 0.196133 7.84353Z"
            fill={color}
          />
          <path
            d="M13.3798 4.69974C13.3798 5.06978 13.6798 5.36974 14.0498 5.36974C14.4199 5.36974 14.7198 5.06978 14.7198 4.69974L14.7198 0.679742C14.7198 0.309701 14.4199 0.00974175 14.0498 0.00974172L10.0298 0.00974136C9.65979 0.00974133 9.35983 0.3097 9.35983 0.679741C9.35983 1.04978 9.65979 1.34974 10.0298 1.34974L13.3798 1.34974L13.3798 4.69974Z"
            fill={color}
          />
        </svg>
      );
    case "stable-arrow":
      return (
        <svg
          width="14"
          height="9"
          viewBox="0 0 14 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.7778 5.02948C14.0741 4.73663 14.0741 4.26103 13.7778 3.96818L9.98597 0.21964C9.68973 -0.0732142 9.20864 -0.0732141 8.9124 0.21964C8.61616 0.512495 8.61616 0.988091 8.9124 1.28095L11.4103 3.75029L0.758371 3.75029C0.338897 3.75029 5.24019e-07 4.08532 5.60272e-07 4.5C5.96524e-07 4.91468 0.338897 5.24971 0.758371 5.24971L11.4103 5.24971L8.9124 7.71906C8.61616 8.01191 8.61616 8.48751 8.9124 8.78036C9.20864 9.07321 9.68973 9.07321 9.98597 8.78036L13.7778 5.03182L13.7778 5.02948Z"
            fill={color}
          />
        </svg>
      );
  }
  return null;
};
